import { render } from "./OdooSyncDialog.vue?vue&type=template&id=64194f14"
import script from "./OdooSyncDialog.vue?vue&type=script&lang=js"
export * from "./OdooSyncDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__